<template>
    <a class="align-items-center mr-n1 mr-sm-0 d-none d-md-flex" :href="isLogged ? '/' + lang + '/' + translate + '/dashboard' : '/' + lang + '/register'" @click="toggleLogin">
        <div class="position-relative d-flex">
            <img class="m-0" width="30" :src="'/images/area-utente/user-' + theme + '.svg'" alt="icona" />
            <span v-if="isLogged" class="is-logged"></span>
        </div>
    </a>
</template>

<script>
    export default {
        props: ['isLogged', 'theme', 'lang'],
        data() {
            return {
                counter: 0
            }
        },
        mounted() {
        },
        computed: {
          translate() {
              if(this.lang == 'en') {
                  return 'user-account';
              }
              return 'area-utente';
          }
        },
        methods: {
            toggleLogin() {
                /*if(!this.isLogged) {
                    this.$eventHub.$emit('login', {});
                }*/
            },
        },
        beforeDestroy() {
        },

    }
</script>
